import { render } from "./list-surat-keluar.vue?vue&type=template&id=e379712e&scoped=true"
import script from "./list-surat-keluar.vue?vue&type=script&lang=js"
export * from "./list-surat-keluar.vue?vue&type=script&lang=js"

import "./list-surat-keluar.vue?vue&type=style&index=0&id=e379712e&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e379712e"]])

export default __exports__